module.exports = __webpack_public_path__ + "static/media/jasper-19.38654eec.jpg";